'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var DialogTitle = require('@material-ui/core/DialogTitle');
var Typography = require('@material-ui/core/Typography');
var IconButton = require('@material-ui/core/IconButton');
var CloseIcon = require('@material-ui/icons/Close');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DialogTitle__default = /*#__PURE__*/_interopDefaultLegacy(DialogTitle);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);

var _excluded = ["children", "onClose"];
var useStyles = styles.makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    position: 'relative'
  },
  closeButtonContainer: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  },
  closeButton: {
    color: theme.palette.text.secondary
  }
}));
/**
 * A dyanmic content panel that opens on the right side of the viewport.
 */

var ClosableDialogTitle = _ref => {
  var {
    children,
    onClose
  } = _ref,
      other = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/React__default['default'].createElement(DialogTitle__default['default'], _rollupPluginBabelHelpers['extends']({
    className: classes.root
  }, other), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "h2",
    component: "div"
  }, children), onClose ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.closeButtonContainer
  }, /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React__default['default'].createElement(CloseIcon__default['default'], null))) : null);
};
ClosableDialogTitle.propTypes = {
  /** The content of the ClosableDialogTitle. */
  children: index.node.isRequired,

  /**
   * Callback for closing the ClosableDialogTitle.
   *
   * @param {object} event Source event for the onClick callback.
   */
  onClose: index.func.isRequired
};

exports.ClosableDialogTitle = ClosableDialogTitle;
exports.default = ClosableDialogTitle;
